<div class="xy-container footer-outer bg-blue-night">
  <div class="footer-container">
    <img class="logo--footer" src="/assets/pollstar_logo.svg" alt="">
    <br>
    <span class="text-small">Pollstar è un'iniziativa con finalità scientifiche senza fini di lucro e fa parte
    delle attività di ricerca del Dipartimento di Culture, Politica e Società dell'Università di Torino.
    </span>
    <br>
    <span style="display: flex; justify-content: center">
      <a routerLink="/contact-us" class="link text-white text-small" href="">Contatti</a>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <a routerLink="/privacy-policy" class="link text-white text-small" href="">Privacy Policy</a>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <a routerLink="/terms-of-service" class="link text-white text-small" href="">Termini di servizio</a>
    </span>
  </div>
</div>
